// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-card {
    border-radius: 12px;
    box-shadow: inset 0px -2px 3px 3px #e9e0e085;
    background-color: #fff;
    margin-bottom: 8px;
}

.list-card-border-success {
    border-left: 6px solid #4caf50;
}

.list-card-border-secondary {
    border-left: none;
}

.list-card-border-info {
    border-left: 6px solid #2196f3;
}

.list-card-border-warning {
    border-left: 6px solid #ff9800;
}

.list-card-border-primary {
    border-left: 6px solid #9c27b0;
}

.list-card-layout {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    padding: 16px;
    padding-left: 5px;
}

.list-card-media {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    height: 116px;
    width: 158px;
    min-width: 158px;
    border-radius: 12px;
    margin-left: 11px;
}

.list-card-media-success {
    background-color: #4caf50;
}

.list-card-media-secondary {
    background-color: #9e9e9e;
}

.list-card-media-info {
    background-color: #2196f3;
}

.list-card-media-warning {
    background-color: #ff9800;
}

.list-card-media-primary {
    background-color: #9c27b0;
}

.list-card-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.list-card-play-icon {
    position: absolute;
    font-size: 30px;
    bottom: 5px;
    right: 5px;
    background-color: white;
    border-radius: 56%;
}

.list-card-image {
    height: 100%;
}

.list-card-image-full {
    width: 100%;
    object-fit: inherit;
}

.list-card-image-logo {
    width: 80%;
    object-fit: contain;
}

.list-card-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0 16px !important;
    min-width: 0;
}

.list-card-row {
    display: flex;
    align-items: center;
    gap: 16px;
}

.list-card-top-row {
    margin-bottom: 8px;
}

.list-card-title {
    flex: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    font-weight: bold;
    font-size: 16px;
    min-width: 0;
}

.list-card-category {
    flex: 1;
    font-weight: bold;
    color: grey;
    text-transform: uppercase;
    font-size: 12px;
}

.list-card-product-chip {
    font-size: small;
    background-color: #f9f3f3;
}

.list-card-description {
    height: 40px;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    color: grey;
    font-size: 14px;
    margin-bottom: 8px;
}

.list-card-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: auto;
}

.list-card-link-container {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.list-card-community-icon {
    width: 2rem;
    height: 100%;
}

.list-card-release-icon {
    height: 100%;
    margin-right: 3px;
}

.list-card-expand-button {
    border-radius: 50%;
    background-color: #F6F6F9;
    padding: 8px;
    margin-left: auto !important;
}

.list-card-expand-button:hover {
    background-color: #e8e8eb;
}

.list-card-dialog-paper {
    max-width: 680px;
    border-radius: 16px !important;
    overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/list/ListCard.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,4CAA4C;IAC5C,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,gBAAgB;AACpB","sourcesContent":[".list-card {\n    border-radius: 12px;\n    box-shadow: inset 0px -2px 3px 3px #e9e0e085;\n    background-color: #fff;\n    margin-bottom: 8px;\n}\n\n.list-card-border-success {\n    border-left: 6px solid #4caf50;\n}\n\n.list-card-border-secondary {\n    border-left: none;\n}\n\n.list-card-border-info {\n    border-left: 6px solid #2196f3;\n}\n\n.list-card-border-warning {\n    border-left: 6px solid #ff9800;\n}\n\n.list-card-border-primary {\n    border-left: 6px solid #9c27b0;\n}\n\n.list-card-layout {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    padding: 16px;\n    padding-left: 5px;\n}\n\n.list-card-media {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    position: relative;\n    height: 116px;\n    width: 158px;\n    min-width: 158px;\n    border-radius: 12px;\n    margin-left: 11px;\n}\n\n.list-card-media-success {\n    background-color: #4caf50;\n}\n\n.list-card-media-secondary {\n    background-color: #9e9e9e;\n}\n\n.list-card-media-info {\n    background-color: #2196f3;\n}\n\n.list-card-media-warning {\n    background-color: #ff9800;\n}\n\n.list-card-media-primary {\n    background-color: #9c27b0;\n}\n\n.list-card-thumbnail {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.list-card-play-icon {\n    position: absolute;\n    font-size: 30px;\n    bottom: 5px;\n    right: 5px;\n    background-color: white;\n    border-radius: 56%;\n}\n\n.list-card-image {\n    height: 100%;\n}\n\n.list-card-image-full {\n    width: 100%;\n    object-fit: inherit;\n}\n\n.list-card-image-logo {\n    width: 80%;\n    object-fit: contain;\n}\n\n.list-card-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    padding: 0 16px !important;\n    min-width: 0;\n}\n\n.list-card-row {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.list-card-top-row {\n    margin-bottom: 8px;\n}\n\n.list-card-title {\n    flex: 2;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    white-space: normal;\n    font-weight: bold;\n    font-size: 16px;\n    min-width: 0;\n}\n\n.list-card-category {\n    flex: 1;\n    font-weight: bold;\n    color: grey;\n    text-transform: uppercase;\n    font-size: 12px;\n}\n\n.list-card-product-chip {\n    font-size: small;\n    background-color: #f9f3f3;\n}\n\n.list-card-description {\n    height: 40px;\n    width: 90%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    white-space: normal;\n    color: grey;\n    font-size: 14px;\n    margin-bottom: 8px;\n}\n\n.list-card-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: auto;\n}\n\n.list-card-link-container {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.list-card-community-icon {\n    width: 2rem;\n    height: 100%;\n}\n\n.list-card-release-icon {\n    height: 100%;\n    margin-right: 3px;\n}\n\n.list-card-expand-button {\n    border-radius: 50%;\n    background-color: #F6F6F9;\n    padding: 8px;\n    margin-left: auto !important;\n}\n\n.list-card-expand-button:hover {\n    background-color: #e8e8eb;\n}\n\n.list-card-dialog-paper {\n    max-width: 680px;\n    border-radius: 16px !important;\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
